import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { fetchAutoCompleteResults } from '../../../actions/autocompleteActions';
import media from '../../../constants/media';
import ITAutocompleteReducer from '../../../interfaces/autocomplete/autocompleteReducer';
import { IStore } from '../../../reducers';
import RichTextTitle from '../../base/richTextTitle';
import SearchForm from './searchForm';
import SearchResults from './searchResults';

const HeroContainer = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-bottom: 28px;

	${media.desktopSmall`
		padding-top: 24px;
		padding-inline: 18%;
	`};
`;

const Root = styled.div`
	margin-top: 150px;
`;

interface Props {
	title: string;
	inputPlaceholder: string;
}

const Search: FC<Props> = ({ title, inputPlaceholder }) => {
	const dispatch = useDispatch<any>();
	const autocompleteReducer: ITAutocompleteReducer = useSelector<IStore, ITAutocompleteReducer>(
		store => store.autocompleteReducer
	);
	const { icelandicPages, englishPages } = autocompleteReducer;

	useEffect(() => {
		if (icelandicPages.length === 0 && englishPages.length === 0) {
			dispatch(fetchAutoCompleteResults());
		}
	}, [dispatch, icelandicPages, englishPages]);

	return (
		<Root>
			<HeroContainer>
				<RichTextTitle content={title} type="h3" />
				<SearchForm inputPlaceholder={inputPlaceholder} />
			</HeroContainer>
			<SearchResults />
		</Root>
	);
};

export default Search;
